import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import ResumeSGChargeContMain from "presentation/view/container/ResumeSGCharge/ResumeSGChargeContMain";

CommonEntrypoint(<ResumeSGChargeContMain />)